The value of `CandidateProfile.profileId` for the requested object.
